import React, { Fragment, FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { getTypeNameCapitalized, localize } from "src/l10n";

interface IApprovalRequestProps {
    notification: Spintr.IApprovalRequestNotification;
}
interface IApprovalAcceptedProps {
    notification: Spintr.IApprovalAcceptedNotification;
}
interface IApprovalDeclinedProps {
    notification: Spintr.IApprovalDeclinedNotification;
}

export const ApprovalRequestNotification: FunctionComponent<IApprovalRequestProps> = ({ notification }) => {
    if (!notification) return null;
    return (
        <Fragment>
            {getTypeNameCapitalized(notification.uberType, { form: "singular", case: "definite" }) + " "}
            <Link to={`/goto/${notification.uberId ?? notification.objectId}`}>
                {notification.uberName}
            </Link>
            {" " + localize("HarKommitInForGodkannande").toLowerCase()}.
        </Fragment>
    );
};

export const ApprovalAcceptedNotification: FunctionComponent<IApprovalAcceptedProps> = ({ notification }) => {
    if (!notification) return null;
    return (
        <Fragment>
            {getTypeNameCapitalized(notification.uberType, { form: "singular", case: "definite" }) + " "}
            <Link to={`/goto/${notification.uberId ?? notification.objectId}`}>{notification.uberName}</Link>
            {" " + localize("HarBlivitGodkandPublicerad").toLowerCase()}.
        </Fragment>
    );
};

export const ApprovalDeclinedNotification: FunctionComponent<IApprovalDeclinedProps> = ({ notification }) => {
    if (!notification) return null;
    return (
        <Fragment>
            {getTypeNameCapitalized(notification.uberType, { case: "possessive" }) + " "}
            <Link to={`/goto/${notification.uberId ?? notification.objectId}`}>{notification.uberName}</Link>
            {" " + localize("HarBlivitAvslagen").toLowerCase()}
            {notification.rejectionMessage && (
                <> {localize("MedMeddelandet")}: "{notification.rejectionMessage}"</>
            )}
            .
        </Fragment>
    );
};